import request from '@/util/request'

//设备详情头部信息 
export function OperationHeadInfo(siteId,deviceId){
	return request({
		url:`/device-s/device/${siteId}/${deviceId}`,
		method:'get'
	})
}

//连接信息父系统
export function LinkParentSysListGet(siteId,deviceId){
	return request({
		url:`/device-s/device/${siteId}/${deviceId}/parent`,
		method:'get'
	})
}

//连接信息子系统
export function LinkChildSysListGet(siteId,deviceId,data){
	return request({
		url:`/device-s/device/${siteId}/${deviceId}/child`,
		method:'get',
		params: data
	})
}

//获取通讯关系
export function apiGetContentList(id){
	return request({
		url:`/device-s/device/get-communication/${id}`,
		method:'get'
	});
	// return new Promise(resolve=>{
	// 	resolve([
	// 		{
	// 			"sn": "10F100000101",
	// 			"parentSn": null,
	// 			"topSn": "10F100000101",
	// 			"sortorder": 1,
	// 			"deviceType": 13,
	// 			"deviceState": null,
	// 			"collectionTime": 1568626565.000000000,
	// 			"childList": [
	// 				{
	// 					"sn": "80061-Igen",
	// 					"parentSn": "10F100000101",
	// 					"topSn": "10F100000101",
	// 					"sortorder": 2,
	// 					"deviceType": 14,
	// 					"deviceState": null,
	// 					"collectionTime": 1567049179.000000000,
	// 					"childList": [
	// 						{
	// 							"sn": "1600080061A1",
	// 							"parentSn": "80061-Igen",
	// 							"topSn": "10F100000101",
	// 							"sortorder": 3,
	// 							"deviceType": 15,
	// 							"deviceState": null,
	// 							"collectionTime": 1567049179.000000000,
	// 							"childList": null
	// 						},
	// 						{
	// 							"sn": "1600080061A3",
	// 							"parentSn": "80062-Igen",
	// 							"topSn": "10F100000101",
	// 							"sortorder": 6,
	// 							"deviceType": 15,
	// 							"deviceState": null,
	// 							"collectionTime": 1567049179.000000000,
	// 							"childList": null
	// 						},
	// 						{
	// 							"sn": "1600080061A11",
	// 							"parentSn": "80061-Igen",
	// 							"topSn": "10F100000101",
	// 							"sortorder": 3,
	// 							"deviceType": 15,
	// 							"deviceState": null,
	// 							"collectionTime": 1567049179.000000000,
	// 							"childList": null
	// 						},
	// 						{
	// 							"sn": "1600080061A2",
	// 							"parentSn": "80061-Igen",
	// 							"topSn": "10F100000101",
	// 							"sortorder": 4,
	// 							"deviceType": 15,
	// 							"deviceState": null,
	// 							"collectionTime": 1567049179.000000000,
	// 							"childList": null
	// 						}
	// 					]
	// 				},
	// 				{
	// 					"sn": "80062-Igen",
	// 					"parentSn": "10F100000101",
	// 					"topSn": "10F100000101",
	// 					"sortorder": 5,
	// 					"deviceType": 14,
	// 					"deviceState": null,
	// 					"collectionTime": 1567049178.000000000,
	// 					"childList": [
	// 						{
	// 							"sn": "1600080061A31",
	// 							"parentSn": "80062-Igen",
	// 							"topSn": "10F100000101",
	// 							"sortorder": 6,
	// 							"deviceType": 15,
	// 							"deviceState": null,
	// 							"collectionTime": 1567049179.000000000,
	// 							"childList": null
	// 						},
	// 						{
	// 							"sn": "1600080061A12",
	// 							"parentSn": "80061-Igen",
	// 							"topSn": "10F100000101",
	// 							"sortorder": 3,
	// 							"deviceType": 15,
	// 							"deviceState": null,
	// 							"collectionTime": 1567049179.000000000,
	// 							"childList": null
	// 						},
	// 						{
	// 							"sn": "1600080061A21",
	// 							"parentSn": "80061-Igen",
	// 							"topSn": "10F100000101",
	// 							"sortorder": 4,
	// 							"deviceType": 15,
	// 							"deviceState": null,
	// 							"collectionTime": 1567049179.000000000,
	// 							"childList": null
	// 						}
	// 					]
	// 				},
	// 				{
	// 					"sn": "80063-Igen",
	// 					"parentSn": "10F100000101",
	// 					"topSn": "10F100000101",
	// 					"sortorder": 7,
	// 					"deviceType": 14,
	// 					"deviceState": null,
	// 					"collectionTime": 1567049179.000000000,
	// 					"childList": [
	// 						{
	// 						"sn": "1600080061A4",
	// 						"parentSn": "80063-Igen",
	// 						"topSn": "10F100000101",
	// 						"sortorder": 8,
	// 						"deviceType": 15,
	// 						"deviceState": null,
	// 						"collectionTime": 1567049179.000000000,
	// 						"childList": null
	// 						}
	// 					]
	// 				},
	// 				{
	// 					"sn": "1600080063A2",
	// 					"parentSn": "10F100000101",
	// 					"topSn": "10F100000101",
	// 					"sortorder": 9,
	// 					"deviceType": 15,
	// 					"deviceState": null,
	// 					"collectionTime": 1567049179.000000000,
	// 					"childList": null
	// 				}
	// 			]
	// 		}
	// 	]);
	// });
}

//获取组网关系
export function apiGetNetworkList(sn){
	return request({
		url:`/deviceConfig-s/mix/networkDeployment/getRelation`,
		method:'get',
		params:{sn}
	});
}



// WEBPACK FOOTER //
// ./src/api/device/detail.js